import { render, staticRenderFns } from "./ImageWithText.vue?vue&type=template&id=7647bdac&"
import script from "./ImageWithText.vue?vue&type=script&lang=js&"
export * from "./ImageWithText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports